import { BookOpen } from "lucide-react";
import { cn } from "@/lib/utils";
import { trackBrochureIntent } from "@/lib/analytics";
import { BROCHURE_TEXT_PATH } from "@/data/solutions";

type Placement = "home_solutions" | "intelligence" | "websites" | "consent" | "cmo" | "seo" | "website_service";

interface Props {
  chapter: number;
  placement: Placement;
  label?: string;
  tone?: "light" | "dark";
  className?: string;
}

/** Links to a chapter in the existing accessible brochure text view. */
export function BrochureChapterLink({ chapter, placement, label = "Read this chapter in our brochure", tone = "light", className }: Props) {
  return (
    <a
      href={`${BROCHURE_TEXT_PATH}#title-${chapter}`}
      onClick={() => trackBrochureIntent("view", placement)}
      data-testid={`link-brochure-${placement}`}
      className={cn(
        "inline-flex items-center gap-2 text-sm font-semibold underline-offset-4 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring rounded-sm",
        tone === "dark" ? "text-white/85 hover:text-white" : "text-primary hover:text-accent",
        className,
      )}
    >
      <BookOpen className="w-4 h-4" aria-hidden="true" />
      {label}
    </a>
  );
}
